import { memo } from 'react'
import { Flex, SimpleGrid, Text, useRadioGroup } from '@chakra-ui/react'

import { useCalendarFilters } from '../../contexts/CalendarFiltersManager/Provider'
import { DATA_FILTER_TYPES } from './constants'
import RadioCard from './components/RadioCard'

const SelectDataFilterType = () => {
  const { dateFilterType, setDateFilterType } = useCalendarFilters()

  const { getRadioProps } = useRadioGroup({
    name: '',
    defaultValue: dateFilterType,
    onChange: (selectedValue) => setDateFilterType(selectedValue),
  })

  return (
    <Flex width="100%" direction="column" gap={2}>
      <Text color="primary" textAlign="center">
        Selecione como você quer filtrar a data
      </Text>
      <SimpleGrid width="100%" columns={[2, 2, 2, 4]} spacing={1}>
        {DATA_FILTER_TYPES.map((value) => {
          const radio = getRadioProps({ value })
          return (
            <RadioCard key={value} {...radio}>
              {value}
            </RadioCard>
          )
        })}
      </SimpleGrid>
    </Flex>
  )
}

export default memo(SelectDataFilterType)
